import { render, staticRenderFns } from "./PlanejamentoAcaoVerbaVariavelFormAnexoArquivo.vue?vue&type=template&id=48fd00fe&scoped=true"
import script from "./PlanejamentoAcaoVerbaVariavelFormAnexoArquivo.vue?vue&type=script&lang=js"
export * from "./PlanejamentoAcaoVerbaVariavelFormAnexoArquivo.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoAcaoVerbaVariavelFormAnexoArquivo.vue?vue&type=style&index=0&id=48fd00fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fd00fe",
  null
  
)

export default component.exports